<script>
  import { inertia } from '@inertiajs/svelte';
  import Icon from '@iconify/svelte';
  import AppLayout from '../../components/AppLayout.svelte';
  import Card from '../../components/ui/Card.svelte';
  import Button from '../../components/ui/Button.svelte';

  let { bins = [] } = $props();
</script>

<AppLayout title="Bins">
  <div class="flex justify-end mb-6">
    <Button href="/bins/new"><Icon icon="mdi:plus" class="mr-1" /> New bin</Button>
  </div>

  {#if bins.length === 0}
    <Card>
      <div class="text-center py-8">
        <Icon icon="mdi:tray-full" class="text-4xl text-secondary-300 mx-auto mb-3" />
        <p class="text-secondary-500 mb-4">No bins yet. A bin is a queue of draft posts an automatic slot can pull from.</p>
        <Button href="/bins/new">Create your first bin</Button>
      </div>
    </Card>
  {:else}
    <div class="flex flex-col gap-3">
      {#each bins as bin}
        <a use:inertia href={`/bins/${bin.id}`} class="card !p-5 hover:border-primary-200 flex items-center justify-between gap-4">
          <div class="flex items-center gap-3">
            <Icon icon="mdi:tray-full" class="text-secondary-400 text-xl" />
            <span class="text-secondary-800 font-medium">{bin.name}</span>
          </div>
          <span class="text-sm text-secondary-500">{bin.item_count} {bin.item_count === 1 ? 'post' : 'posts'} queued</span>
        </a>
      {/each}
    </div>
  {/if}
</AppLayout>
